import { PAYMENT_METHODS, PAYMENT_METHODS_NAME } from '@autopass-web/domain';
import {
  isAppleSupportVersion,
  isLineInAppWebView,
} from '@autopass-web/mochi-payment/utils/support';

export function parsePaymentMethodString(payments: string[]) {
  return payments
    .map((payment) => {
      if (payment === PAYMENT_METHODS.APPLE_PAY) {
        // FIXME: type ApplePaySession is not defined
        if (
          isAppleSupportVersion() &&
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          !!window.ApplePaySession &&
          !isLineInAppWebView()
        ) {
          return 'Apple Pay（需使用 Safari 開啟）';
        }
      }
      return PAYMENT_METHODS_NAME[payment];
    })
    .filter((x) => x)
    .join('、');
}
